export default __webpack_public_path__ + "static/media/number3.98ae2f0c.png";